import * as moment from 'moment';

/**
 * The coding view's date range chips and the info beside them. The last export and the last
 * Connect submission are kept on the group (lastBillingExport* / lastBillingSubmission*, ISO
 * strings in UTC).
 */

/** Where a range chip starts: 'week', 'month', 'last' (export), 'submitted' (to Connect) or 'all'. */
export function codingRangeStart(value: string, group: any, now: moment.Moment = moment()): moment.Moment {
  switch (value) {
    case 'week':
      return now.clone().subtract(7, 'days');
    case 'last':
      return moment.utc(group?.lastBillingExportEndDate).add(1, 'day');
    case 'submitted':
      return moment.utc(group?.lastBillingSubmissionEndDate).add(1, 'day');
    case 'all':
      return now.clone().subtract(100, 'years');
    case 'month':
    default:
      return now.clone().subtract(1, 'month');
  }
}

const when = (iso: string) => moment.utc(iso).format('DD/MM/YYYY HH:mm:ss');
const day = (iso: string) => moment.utc(iso).format('DD/MM/YYYY');

/** One line for the last export and, for Connect practices, one for the last submission; '' when neither. */
export function lastCodingRangesInfo(group: any, includeSubmission: boolean): string {
  const lines: string[] = [];
  if (group?.lastBillingExportCreatedDate) {
    lines.push(`You last exported coding on ${when(group.lastBillingExportCreatedDate)} for ` +
      `${day(group.lastBillingExportStartDate)} to ${day(group.lastBillingExportEndDate)}`);
  }
  if (includeSubmission && group?.lastBillingSubmissionCreatedDate) {
    lines.push(`You last submitted coding to Connect on ${when(group.lastBillingSubmissionCreatedDate)} for ` +
      `${day(group.lastBillingSubmissionStartDate)} to ${day(group.lastBillingSubmissionEndDate)}`);
  }
  return lines.join('\n');
}
